// extracted by mini-css-extract-plugin
export default {"root":"NoFilterResults-module__root___2Db0Y","resultText":"NoFilterResults-module__resultText___ayUmc"};